import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { MenuItems } from 'src/app/shared/menu-items/menu-items';
import { LoaderService } from '../../services/loader/loader.service';
import { CommunicationService } from '../../services/communication/communication.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Auth0Service } from '../../authentication/auth0/auth0.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
/**
 * This component gets invoked after a successful login, this component contains a header, footer, side menu, and child component container.
 */
@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
  styleUrls: []
})
export class FullComponent implements OnDestroy, AfterViewInit {
  @ViewChild('snav') snav;
  mobileQuery: MediaQueryList;
  dir = 'ltr';
  green: boolean;
  blue: boolean;
  dark: boolean;
  minisidebar: boolean;
  boxed: boolean;
  danger: boolean;
  showHide: boolean;
  sidebarOpened;
  isShow = false;
  boardName = '';
  routerSubscriber;

  public config: PerfectScrollbarConfigInterface = {};
  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private loader: LoaderService,
    private auth0: Auth0Service,
    private router: Router,
    private communicationService: CommunicationService
  ) {
    // this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this.mobileQuery = media.matchMedia('(min-width: 1025px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.loader.progressLoader.subscribe(state=>{
      setTimeout(()=>{
        this.isShow = state;
      },10)
    })
    this.communicationService.sidebarMenu.subscribe(res=>{
      if(res)
        this.snav.toggle();
    })

    this.routerSubscriber = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((e:any) => {
      if(e.url.includes('/app/dashboard')){
        const board = e.url.split('?')[0].split('/');
        if(board.length)
          this.boardName = board[board.length-1];
      }else
        this.boardName = '';
    });
    this.communicationService.getCommunications();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.routerSubscriber.unsubscribe();
  }

  ngAfterViewInit() {
    // This is for the topbar search
    // ($('.srh-btn, .cl-srh-btn')).on('click', ()=> {
    //   ($('.app-search')).toggle(200);
    // });
    // This is for the megamenu
  }

/**
 * This function gets invoked once the user clicks on the search button
 * 
 * CareAlly can able to search for particular patient/task by providing name of the patient. It will search patient in fire store, as there is no provisioning to search data on firebase. We unsubscribe all firebase request and call the backend API. Once CareAlly clicks on close button from search box, we do subscribe for all the queues and tasks.
 * 
 * @param status 
 */
  // onSearchBtnClick(status){
  //   if(this.router.url.includes('/app/dashboard')){
  //     this.communicationService.onSearch({ isSearch: status});
  //     ($('.card-search')).toggle(200);
  //   }else{
  //     // ($('.full-search')).toggle(200);
  //   }
  // }

  // onCloseSearch(event){
  //   ($('.card-search')).toggle(200);
  // }

  logout(){
    this.auth0.logout();
  }

}
